import Vibrant from 'node-vibrant';
import { Palette } from 'node-vibrant/lib/color';
import React from 'react';

const getDominantSwatch = (palette: Palette) => {
    let dominant = palette[0];
    const highestPopulation = -1;

    const keys = Object.keys(palette);

    for (let index = 0; index < keys.length; index++) {
        const key = keys[index];
        const swatch = palette[key];

        if (swatch && swatch?.population > highestPopulation) {
            dominant = swatch;
        }
    }

    return dominant;
};

export const useImageColors = (url: string | null) => {
    const [color, setColor] = React.useState<string | null>(null);

    React.useEffect(() => {
        if (!url) {
            return;
        }

        const img = new Image();
        img.src = url;
        img.crossOrigin = 'Anonymous';
        const vibrant = new Vibrant(img, {
            useWorker: true,
            // Low quality
            quality: 5
        });

        vibrant.getPalette().then((palette) => {
            const dominantSwatch = getDominantSwatch(palette);
            setColor(dominantSwatch.hex);
        });
    }, [url]);

    return color;
};
